import React from "react";
import { ExpandMore } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./payroll-merged-collapse-header.style";

interface MyHrPayrollMergedCollapseHeaderProps {
  label: string;
  handleExpandClick: () => void;
  expanded: boolean;
}

export const MyHrPayrollMergedCollapseHeader: React.FC<
  MyHrPayrollMergedCollapseHeaderProps
> = ({ label, handleExpandClick, expanded }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box>
      <Box
        className={
          expanded === true
            ? classes.backgroundColorOnCollapse
            : classes.backgroundColorOffCollapse
        }
        padding="0px 16px"
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="contents" />
          <Box display="flex" flexDirection="row" alignItems="center">
            <Typography
              variant="h6"
              style={{
                padding: "16px 0px",
                marginRight: "28px",
                marginLeft: "16px",
                color: `${theme.palette.gray80.main}`,
              }}
            >
              {label}
            </Typography>
          </Box>
          <IconButton
            id={label}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
            style={
              expanded
                ? {
                    padding: 0,
                    marginRight: "20px",
                    transform: "rotate(180deg)",
                  }
                : {
                    padding: 0,
                    marginRight: "20px",
                  }
            }
          >
            <ExpandMore />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default MyHrPayrollMergedCollapseHeader;
